import { Link } from 'react-router-dom';
import { comics, featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedSection() {
  const featuredList = featuredComics
    .map((id) => comics.find((c) => c.id === id)!)
    .filter(Boolean);

  return (
    <section className="py-10 px-4 md:px-6 max-w-[1280px] mx-auto" aria-label="今日推荐">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-heading text-foreground-900 whitespace-nowrap">
            <strong>今日推荐</strong>
          </h2>
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
            编辑精选
          </span>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          更多推荐 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {featuredList.map((comic) => (
          <ComicCard key={comic.id} comic={comic} size="large" />
        ))}
      </div>
    </section>
  );
}